import { Validation } from "@vuelidate/core";
import { ComputedRef, reactive, Ref } from "vue";
import { ToastInterface } from "vue-toastification";

interface FormRules {
  [key: string]: {
    required: any;
  };
}

interface EvaluationOptions<T, V> {
  form: { name: string };
  formVuelidate: Ref<Validation<FormRules, T>>;
  setQuery: (query: string) => void;
  refetch: () => Promise<void>;
  duplicateItems: ComputedRef<V[] | undefined>;
  data: V[];
  toast: ToastInterface;
  handleCreate: () => Promise<void>;
  isConfirmed: Ref<boolean>;
  isCoincidence: Ref<boolean>;
}

export const verifyIsDuplicateData = async <T, V>(
  options: EvaluationOptions<T, V>,
) => {
  const {
    form,
    formVuelidate,
    setQuery,
    refetch,
    duplicateItems,
    data,
    toast,
    handleCreate,
    isConfirmed,
    isCoincidence,
  } = options;

  for (const field of formVuelidate.value.$silentErrors) {
    if (!Array.isArray(field.$message)) {
      toast.error(field.$message);
      return;
    }
  }

  isConfirmed.value = true;

  setQuery(form.name?.toLocaleLowerCase());
  await refetch();

  if (!duplicateItems.value?.length) {
    if (data?.length) {
      console.log(data);

      isCoincidence.value = true;
    } else {
      await handleCreate();
    }
  } else {
    isConfirmed.value = false;
    toast.error(`Esta cadena con este nombre ya existe: ${form.name}`);
    return;
  }
};
